<script setup>
import Modal from 'dashboard/components/Modal.vue';
import ModalHeader from 'dashboard/components/ModalHeader.vue';
import FilterOptionGroup from '../Filters/FilterOptionGroup.vue';

defineProps({
  show: { type: Boolean, required: true },
  filters: { type: Array, required: true },
});

const emit = defineEmits(['close', 'addFilter', 'clearGroup', 'selectGroup']);
</script>

<template>
  <Modal
    :show="show"
    size="medium"
    modal-type="centered"
    @update:show="emit('close')"
    @close="emit('close')"
  >
    <ModalHeader :header-title="$t('SLA_REPORTS.FILTERS.TITLE')" />

    <div class="px-8 pb-6 max-h-[65vh] overflow-y-auto">
      <FilterOptionGroup
        v-for="filter in filters"
        :key="filter.type"
        :title="filter.name"
        :options="filter.options"
        :selected-ids="filter.selectedIds"
        @toggle-option="emit('addFilter', $event)"
        @clear-all="emit('clearGroup', filter.type)"
        @select-all="emit('selectGroup', filter.type)"
      />
    </div>
  </Modal>
</template>
